<template>
  <html id="printableArea" style="width:100%;overflow-y:visible">
    <head>
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
      <title>Печать отчета</title>
    </head>
    <body>
      <div>
        <v-flex xs12 v-if="report">
          <v-card class="pa-3">
            <center style="font-size:8pt">
              Отчет по организации бесплатного горячего питания начальных классов
              за {{monthName}} {{month.split('-')[0]}} года
            </center>
            <br><br>
            <hr>
            <center style="font-size:8pt">(наименование общеобразовательной организации)</center>
            <br>
            <table
              width="100%"
              border="1"
              cellpadding="0"
              cellspacing="0"
              style="font-size:8pt;border-collapse:collapse;"
              class="my-3"
            >
              <tr align="center" valign="top">
                <th rowspan="2">Наименование категории получателя услуги</th>
                <th colspan="3">Количество учащихся,человек (всего), по Приказу о предоставлении бесплатного питания</th>
                <th colspan="2">Число дней питания</th>
                <th colspan="3">Количество дето/дней предоставления питания в соответствии с табелем</th>
              </tr>
              <tr align="center" valign="top">
                <th>при 5ке</th>
                <th>при 6ке</th>
                <th>итого</th>
                <th>при 5ке</th>
                <th>при 6ке</th>
                <th>при 5ке</th>
                <th>при 6ке</th>
                <th>итого</th>
              </tr>
              <tr align="center" valign="top">
                <th>1</th>
                <th>2</th>
                <th>3</th>
                <th>4=2+3</th>
                <th>5</th>
                <th>6</th>
                <th>7</th>
                <th>8</th>
                <th>9=8+7</th>
              </tr>
              <template v-for="pos in 4">
                <tr :key="`${pos}1`" align="center" valign="top">
                  <td align="left">Учащиеся {{pos}}-x классов по основным общеобразовательным программам начального общего образования, из них:</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td> </td>
                  <td> </td>
                  <td>{{report.filter(x => x.studytype === 5 && x.positionname.startsWith(`${pos}`)).reduce((a, b) => a + parseInt(b.dayscount), 0)}}</td>
                  <td>{{report.filter(x => x.studytype === 6 && x.positionname.startsWith(`${pos}`)).reduce((a, b) => a + parseInt(b.dayscount), 0)}}</td>
                  <td>{{report.filter(x => x.positionname.startsWith(`${pos}`)).reduce((a ,b) => a + parseInt(b.dayscount), 0)}}</td>
                </tr>
                <tr :key="`${pos}2`" align="center" valign="top">
                  <td align="right">учащиеся в 1 смену:</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td> </td>
                  <td> </td>
                  <td>{{report.filter(x => x.studytype === 5 && x.positionname.startsWith(`${pos}`) && x.saletype.includes('1 смена')).reduce((a, b) => a + parseInt(b.dayscount), 0)}}</td>
                  <td>{{report.filter(x => x.studytype === 6 && x.positionname.startsWith(`${pos}`) && x.saletype.includes('1 смена')).reduce((a, b) => a + parseInt(b.dayscount), 0)}}</td>
                  <td>{{report.filter(x => x.positionname.startsWith(`${pos}`) && x.saletype.includes('1 смена')).reduce((a ,b) => a + parseInt(b.dayscount), 0)}}</td>
                </tr>
                <tr :key="`${pos}3`" align="center" valign="top">
                  <td align="right">учащиеся во 2 смену:</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td> </td>
                  <td> </td>
                  <td>{{report.filter(x => x.studytype === 5 && x.positionname.startsWith(`${pos}`) && x.saletype.includes('2 смена')).reduce((a, b) => a + parseInt(b.dayscount), 0)}}</td>
                  <td>{{report.filter(x => x.studytype === 6 && x.positionname.startsWith(`${pos}`) && x.saletype.includes('2 смена')).reduce((a, b) => a + parseInt(b.dayscount), 0)}}</td>
                  <td>{{report.filter(x => x.positionname.startsWith(`${pos}`) && x.saletype.includes('2 смена')).reduce((a ,b) => a + parseInt(b.dayscount), 0)}}</td>
                </tr>
              </template>
              <tr align="center" valign="top">
                <td align="left"><b>Всего</b></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{report.filter(x => x.studytype === 5).reduce((a, b) => a + parseInt(b.dayscount), 0)}}</td>
                <td>{{report.filter(x => x.studytype === 6).reduce((a, b) => a + parseInt(b.dayscount), 0)}}</td>
                <td>{{report.reduce((a, b) => a + parseInt(b.dayscount), 0)}}</td>
              </tr>
              <tr align="center" valign="top">
                <td align="right"><b>учащиеся в 1 смену</b></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{report.filter(x => x.studytype === 5 && x.saletype.includes('1 смена')).reduce((a, b) => a + parseInt(b.dayscount), 0)}}</td>
                <td>{{report.filter(x => x.studytype === 6 && x.saletype.includes('1 смена')).reduce((a, b) => a + parseInt(b.dayscount), 0)}}</td>
                <td>{{report.filter(x => x.saletype.includes('1 смена')).reduce((a, b) => a + parseInt(b.dayscount), 0)}}</td>
              </tr>
              <tr align="center" valign="top">
                <td align="right"><b>учащиеся во 2 смену</b></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{report.filter(x => x.studytype === 5 && x.saletype.includes('2 смена')).reduce((a, b) => a + parseInt(b.dayscount), 0)}}</td>
                <td>{{report.filter(x => x.studytype === 6 && x.saletype.includes('2 смена')).reduce((a, b) => a + parseInt(b.dayscount), 0)}}</td>
                <td>{{report.filter(x => x.saletype.includes('2 смена')).reduce((a, b) => a + parseInt(b.dayscount), 0)}}</td>
              </tr>
            </table>
            <br><br><br>
            <table width="100%" cellpadding="0" cellspacing="0" style="font-size:8pt;border:none;">
              <tr style="height:40px;">
                <td style="vertical-align:top">Руководитель общеобразовательной организации</td>
                <v-spacer></v-spacer>
                <td>
                  <hr width="300px">(подпись)
                </td>
                <v-spacer></v-spacer>
                <td>
                  <hr width="300px">/ФИО/
                </td>
              </tr>
              <tr style="height:40px;">
                <td style="vertical-align:top">Ответственный по организации питания общеобразовательной организации</td>
                <v-spacer></v-spacer>
                <td>
                  <hr width="300px">(подпись)
                </td>
                <v-spacer></v-spacer>
                <td>
                  <hr width="300px">/ФИО/
                </td>
              </tr>
              <tr style="height:40px;">
                <td style="vertical-align:top">Руководитель {{report[0].org}}</td>
                <v-spacer></v-spacer>
                <td>
                  <hr width="300px">(подпись)
                </td>
                <v-spacer></v-spacer>
                <td>
                  <hr width="300px">/ФИО/
                </td>
              </tr>
              <tr style="height:40px;">
                <td style="vertical-align:top">Представитель {{report[0].org}}</td>
                <v-spacer></v-spacer>
                <td>
                  <hr width="300px">(подпись)
                </td>
                <v-spacer></v-spacer>
                <td>
                  <hr width="300px">/ФИО/
                </td>
              </tr>
              <tr style="height:40px;">
                <td style="vertical-align:top">Дата составления</td>
                <v-spacer></v-spacer>
                <td>
                  {{today}}
                  <hr width="300px">
                </td>
              </tr>
            </table>
            <table  width="100%" style="font-size:8pt;">
              <tr style="height:40px;">
                <td  style="vertical-align:top;width:300px">Контактный телефон, ФИО исполнителя (полностью)</td>
                <td>
                  <hr>
                </td>
              </tr>
            </table>
          </v-card>
        </v-flex>
      </div>
    </body>
  </html>
</template>

<script>
import moment from 'moment'
// import ExcelJS from 'exceljs'
export default {
  name: 'PSFReportTable',
  props: [ 'report', 'month' ],
  computed: {
    monthName () {
      moment.locale('ru')
      return moment.months()[parseInt(this.month.split('-')[1]) - 1]
    },
    today () {
      return moment().format('DD.MM.YYYY')
    }
  }
}
</script>

<style lang="css" scoped>
</style>
